import type { StyledRowProps } from '@viewup/ui';
import { AddUser, Alarm, ArrowRight, HeartCheck, Icon, Row, Typography } from '@viewup/ui';
import type {
  GetViewupPlusSnsAccountsByUserUuidOkDto,
  GetViewupSnsAccountsByUserUuidOkDto,
} from 'viewup-api';

export const informationStyle: StyledRowProps = {
  alignItems: 'center',
  br: 12,
  css: { cursor: 'pointer' },
  height: 40,
  justifyContent: 'space-between',
  px: 12,
  py: 8,
  zIndex: 1,
};

export const handleChangeStatus = (
  snsAccounts: GetViewupSnsAccountsByUserUuidOkDto,
  snsPlusAccounts: GetViewupPlusSnsAccountsByUserUuidOkDto,
) => {
  if (snsAccounts.data.length === 0 && snsPlusAccounts.data.length === 0) {
    return (
      <>
        <Row alignItems='center' gap={4}>
          <Icon color='icon.interactive.primary' size='XS' source={AddUser} />
          <Typography color='text.tertiary' fontType='body2.regular'>
            계정을 추가해 볼까요?
          </Typography>
        </Row>
        <Icon size='XS' source={ArrowRight} />
      </>
    );
  }
  if (
    snsAccounts.data.find((item) => item.snsAccountError) ||
    snsPlusAccounts.data.find((item) => item.snsAccountError)
  ) {
    return (
      <>
        <Row alignItems='center' gap={4}>
          <Icon color='icon.danger' size='XS' source={Alarm} />
          <Typography color='text.tertiary' fontType='body2.regular'>
            확인이 필요한 계정이{' '}
            <Typography color='text.danger' fontType='body2.regular'>
              {snsAccounts.data.filter((item) => item.snsAccountError).length +
                snsPlusAccounts.data.filter((item) => item.snsAccountError).length}
              개
            </Typography>
            있어요
          </Typography>
        </Row>
        <Icon size='XS' source={ArrowRight} />
      </>
    );
  }

  return (
    <>
      <Row alignItems='center' gap={4}>
        <Icon color='icon.interactive.primary' size='XS' source={HeartCheck} />
        <Typography color='text.tertiary' fontType='body2.regular'>
          모든 계정의 상태가 완벽해요!
        </Typography>
      </Row>
      <Icon size='XS' source={ArrowRight} />
    </>
  );
};
